import React from "react";
import { useAppSelector } from "@/store/store";
import { Divider, Typography, Box } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import { MessageListItem } from "./MessageListItem";
import { messageListSelectors } from "../../../modules/ticket/ticketDetail/messages/messageListSlice";
import { getDayKey, formatDayHeader } from "../../../functions/time";

const MessagesSection = () => {
  const messages = useAppSelector(messageListSelectors.selectAll);

  // sort by createdAt ascending to group chronologically
  const sorted = (messages || [])
    .slice()
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  // group messages by calendar day
  const groups = [];
  let currentKey = null;
  for (const msg of sorted) {
    const key = getDayKey(msg.createdAt);
    if (key !== currentKey) {
      currentKey = key;
      groups.push({ key, header: formatDayHeader(msg.createdAt), items: [] });
    }
    groups[groups.length - 1].items.push(msg);
  }

  return (
    <>
      {sorted && sorted.length > 0 && (
        <>
          <Divider />
          <CardContent>
            {groups.map((group) => (
              <Box key={group.key} sx={{ mb: 1 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  align="center"
                  sx={{ display: "block", mb: 0.5 }}
                >
                  {group.header}
                </Typography>
                {group.items.map((message) => (
                  <MessageListItem key={message.id} message={message} />
                ))}
              </Box>
            ))}
          </CardContent>
        </>
      )}
    </>
  );
};

export default MessagesSection;
